import React from "react";
import { format } from "date-fns";
import editIcon from "../../../../static/images/plus-sign.svg";
import styles from "../../../secondary/VerticalTab/verticalTab.module.scss";
import style from "./treatment.module.scss";
import { normalizeValue } from "../../../../utils";

export const InterventionDropdown = ({
  listOptions,
  selectedInterventionId,
  selectedInterventionName,
  viewDropDown,
  dropDownRef,
  hideButtons,
  isInterventionComplete,
  onToggleDropdown,
  onDropChange,
  onAddIntervention,
}) => {
  return (
    <div className={`${styles.intervention_blk}`}>
      <div className="dropdown">
        <div className={styles.new_select_blk}>
          <input type="hidden" id="interventionId" defaultValue={selectedInterventionId} />

          {listOptions?.length === 0 ? (
            <div className={`${styles.select_heading} interventionName`}>Intervention</div>
          ) : (
            <div className={`${styles.select_heading} interventionName`} onClick={onToggleDropdown} ref={dropDownRef}>
              {selectedInterventionName}
            </div>
          )}

          {isInterventionComplete && hideButtons ? (
            <div className={styles.select_btn}>
              <img src={editIcon} alt="btn" onClick={onAddIntervention} />
            </div>
          ) : (
            <div className={style.disabled_select_btn}>
              <img src={editIcon} alt="btn" />
            </div>
          )}
        </div>

        {viewDropDown && (
          <div className={`dropdown-menu show ${styles.intervene_dropdown}`} ref={dropDownRef}>
            {listOptions?.map((optionValues, i) => (
              <p
                key={i}
                className={`dropdown-item ${optionValues.interventionId === selectedInterventionId ? styles.active_item : ""}`}
                onClick={(e) => onDropChange(e, i, optionValues)}
              >
                <label>{normalizeValue(optionValues.interventionName)}</label>
                <span>
                  Last updated by: <strong>{normalizeValue(optionValues.lastUpdatedBy)}</strong>
                </span>
                <span>Last updated on: {optionValues.lastUpdatedDate ? format(new Date(optionValues.lastUpdatedDate), "MMM dd, yyyy") : ""}</span>
              </p>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
